import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import {
  LoginDto,
  ValidateCodeDto,
  ForgetPasswordDto,
  SetUpPasswordDto,
  LoginResponse,
  ValidateResponse,
} from '@/types'

export const authService = {
  login: async (credentials: LoginDto): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, credentials)
  },

  validateCode: async (data: ValidateCodeDto): Promise<ValidateResponse> => {
    return apiClient.post<ValidateResponse>(API_ENDPOINTS.AUTH.VALIDATE, data)
  },

  forgetPassword: async (data: ForgetPasswordDto): Promise<string> => {
    return apiClient.post<string>(API_ENDPOINTS.AUTH.FORGET_PASSWORD, data)
  },

  setUpPassword: async (data: SetUpPasswordDto): Promise<boolean> => {
    return apiClient.post<boolean>(API_ENDPOINTS.AUTH.SET_PASSWORD, data)
  },
}

